define([
  "globals",
  "jquery",
  "knockout",
  "helpers",
  "jquery-validate",
  "jquery-validate-unobtrusive",
  "jquery-unobtrusive-ajax",
  "jquery-migrate",
  "colorbox"],
function (globals, $, ko, helpers) {

  "use strict";

  var addFormValidation = function() {
    $("#gcc-login-reset-form").submit(function (event) {
      if ($(this).valid()) {
        $("#gcc-login-reset-password-send")
          .text("Please Wait...")
          .prop("disabled", true);
      }
    });

    $("#gcc-login-reset-password-email").on("keyup keypress input propertychange", function () {
      if ($(this).valid()) {
        $("#gcc-login-reset-password-send").prop("disabled", false);
      } else {
        $("#gcc-login-reset-password-send").prop("disabled", true);
      }
    });
  };

  $(function() {

    var isMobile = globals.ssm.states[0].active;

    $("#gcc-login-reset-password").colorbox({
      inline: true,
      width: isMobile ? "90%": "500px",
      maxHeight: "100%",
      scrolling: false,
      transition: "none",
      onOpen: function() {
        if (helpers.isValidEmail($("#gcc-login-email").val())) {
          $("#gcc-login-reset-password-email").val($("#gcc-login-email").val());
          $("#gcc-login-reset-password-send").prop("disabled", false);
        } else {
          $("#gcc-login-reset-password-email").val("");
          $("#gcc-login-reset-password-send").prop("disabled", true);
        }
        $(".field-validation-error").addClass("field-validation-valid");
        $(".field-validation-error").removeClass("field-validation-error");
      },
      onComplete: function() {
        $("#gcc-login-reset-password-email").focus();
      },
      onClosed: function() {
        $.get("/Application/ResetPassword/ResetPassword").done(function(data) {
          $("#bdc-reset-password-modal-content").html(data);
        });
      }
    });

    addFormValidation();

  });

  return {
    addFormValidation: addFormValidation
  }

});
